module.exports = __webpack_public_path__ + "img/eth.f6c5fc22.png";